module.exports = __webpack_public_path__ + "static/media/scaled-medium.e68dcc4a.webp";